import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'

import './ChangePasswordForm.scss'

import Toast from '../../../../components/Toast/Toast'
import TextInput from '../../../../components/Form/TextInput/TextInput'

import { API__USER } from '../../../../api'

const ChangePasswordForm = ({ userDetails, onSuccess = () => {}, t }) => {
    const [isLoading, setIsLoading] = useState(false)

    const [oldPassword, setOldPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [newPassword2, setNewPassword2] = useState('')

    const [errors, setErrors] = useState({})

    const [isDisabledButton, setIsDisabledButton] = useState(false)

    useEffect(() => {
        if (oldPassword.length && newPassword.length && newPassword2.length) {
            setIsDisabledButton(false)
        } else {
            setIsDisabledButton(true)
        }
    }, [oldPassword, newPassword, newPassword2])

    const onSubmit = async () => {
        setIsLoading(true)
        setErrors({})

        try {
            let localErrors = {}

            if (!oldPassword.length) {
                localErrors.oldPassword = [t('Field cannot be empty')]
            }
            if (!newPassword.length) {
                localErrors.newPassword = [t('Field cannot be empty')]
            }
            if (!newPassword2.length) {
                localErrors.newPassword2 = [t('Field cannot be empty')]
            }
            if (Object.keys(localErrors).length) {
                setErrors(localErrors)
                return
            }

            if (newPassword !== newPassword2) {
                setErrors({
                    newPassword: [t('Passwords must match')],
                    newPassword2: [t('Passwords must match')],
                })
                return
            }

            if (oldPassword === newPassword) {
                setErrors({
                    oldPassword: [t('Passwords must be different')],
                    newPassword: [t('Passwords must be different')],
                })
                return
            }

            if (newPassword.length < 6) {
                setErrors({
                    newPassword: [t('Password must be greater than {{value}} symbols', { value: 5 })],
                })
                return
            }

            if (!newPassword.match(/[A-Z]/g)) {
                setErrors({
                    newPassword: [t('Use at least {{value}} uppercase letter', { value: 1 })],
                })
                return
            }
            if (!newPassword.match(/[a-z]/g)) {
                setErrors({
                    newPassword: [t('Use at least {{value}} lowercase letter', { value: 1 })],
                })
                return
            }

            if (newPassword.replace(/\D+/g, '').length < 1) {
                setErrors({
                    newPassword: [t('Use at least {{value}} number', { value: 1 })],
                })
                return
            }

            await API__USER.CHANGE_PASSWORD(userDetails.id, {
                oldPassword,
                newPassword,
            })

            setOldPassword('')
            setNewPassword('')
            setNewPassword2('')

            await onSuccess()
            Toast('success', {
                message: t('Your password is changed successfully'),
            })
        } catch (err) {
            console.error(err)

            if (err.response) {
                const {
                    response: { status, data },
                } = err
                if (status === 400) {
                    if (data.message === 'Old password is not valid') {
                        setErrors({
                            oldPassword: [t('Password is not valid')],
                        })
                        return
                    }
                    if (data.message === 'New password is not valid') {
                        setErrors({
                            newPassword: [t('Password is not valid')],
                        })
                        return
                    }
                    if (data.message === "Old passwords doesn't matches") {
                        setErrors({
                            oldPassword: [t("Old passwords doesn't matches")],
                        })
                        return
                    }
                    if (data.message === 'New password matches with old password') {
                        setErrors({
                            newPassword: [t('Password matches with old password')],
                        })
                        return
                    }
                }
            }

            Toast('error', {})
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="form">
            <div className="form__inputs">
                <div className="form__inputs-block">
                    <TextInput
                        label={t('Current password')}
                        value={oldPassword}
                        controlType="password"
                        errorMessages={errors.oldPassword || []}
                        onUpdate={v => {
                            setOldPassword(v)
                            setErrors({ ...errors, oldPassword: [] })
                        }}
                    />
                </div>
                <div className="form__inputs-block">
                    <TextInput
                        label={t('New password')}
                        value={newPassword}
                        controlType="password"
                        errorMessages={errors.newPassword || []}
                        onUpdate={v => {
                            setNewPassword(v)
                            setErrors({ ...errors, newPassword: [] })
                        }}
                    />
                </div>
                <div className="form__inputs-block">
                    <TextInput
                        label={t('Retype new password')}
                        value={newPassword2}
                        controlType="password"
                        errorMessages={errors.newPassword2 || []}
                        onUpdate={v => {
                            setNewPassword2(v)
                            setErrors({ ...errors, newPassword2: [] })
                        }}
                    />
                </div>
            </div>
            <div className="form__buttons">
                <button
                    className="button"
                    data-size="md"
                    data-variant="primary"
                    disabled={isDisabledButton || isLoading}
                    onClick={() => onSubmit()}
                >
                    {t('Save changes')}
                </button>
            </div>
        </div>
    )
}

export default withTranslation('translations')(ChangePasswordForm)
